import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import HistorySection from '../../../../components/HistorySection';
import { exists } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';

const ModifiedRankinScale = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="functionalPerformance.modifiedRankinScale" />}
    newButton={
      <DocumentCreationButton
        name="modifiedRankinScale"
        text="functionalPerformance.newModifiedRankinScale"
        onClick={startEdit({}, 'modifiedRankinScale')}
        width={20}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
  >
    <HistoryRowListing
      documents={documents}
      headers={
        <React.Fragment>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={7}>
            <FormattedMessage id="functionalPerformance.rating" />
          </Item>
        </React.Fragment>
      }
      contentFormat={(d: IModifiedRankinScale): React.JSX.Element => (
        <>
          <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
          <Item xs={7}>
            {exists(d.rating) ? (
              <React.Fragment>
                {`${d.rating} - `}
                <FormattedMessage id={`functionalPerformance.opts.modifiedRankinScale.rating.${d.rating}`} />
              </React.Fragment>
            ) : (
              '-'
            )}
          </Item>
          <Item xs={3}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </Item>
        </>
      )}
    />
  </HistorySection>
);

interface IOwnProps {
  documents: Array<IModifiedRankinScale>;
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
  view?: IView;
}

export default ModifiedRankinScale;
